<template>
    <b-card no-body>

        <b-modal id="create" title="Oluştur" no-close-on-esc no-close-on-backdrop>
            <bank-installment-campaign-create :banks="banks" v-model="bankInstallmentCampaign"></bank-installment-campaign-create>
            <template #modal-footer><v-executer :action="create" text="Oluştur" :loading="loading"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    search
                    :settings=false
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { SystemParameterApi } from '@/api/system-parameter'
import { BCard } from 'bootstrap-vue'
import BankInstallmentCampaignCreate from './components/BankInstallmentCampaignCreate.vue'
import { SystemDataApi } from '@/api/system-data'

export default {
    components:{
        BCard,
        BankInstallmentCampaignCreate
    },
    data() {
        return {
            loading:false,
            fields:[
                {name:'Banka',key:'BankName',thClass:'w-50'},
                {name:'Taksit Kampanyası',key:'Campaign',thClass:'w-50'},
            ],
            buttons:[
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"secondary",action:this.delete }
            ],
            bankInstallmentCampaign:{
                Id:null,
                Bank:null,
                BankName:null,
                Campaign:null
            },
            banks:[]
        }
    },
    mounted(){
        this.getBanks()
    },
    methods:{
        provider(){
            return SystemParameterApi.BankInstallmentsCampaign()
        },
        clearForm(){
            this.bankInstallmentCampaign.Id = null
            this.bankInstallmentCampaign.Bank = null
            this.bankInstallmentCampaign.BankName = null
            this.bankInstallmentCampaign.Campaign = null
        },
        edit(item){
            this.clearForm()
            this.bankInstallmentCampaign.Id = item.Id
            this.bankInstallmentCampaign.BankName = item.BankName
            this.bankInstallmentCampaign.Bank = item.Bank
            this.bankInstallmentCampaign.Campaign = item.Campaign
            this.$showModal('update')
        },
        createNew(){
            this.clearForm()
            this.$showModal('create')
        },
        create(){
            this.loading = true
            SystemParameterApi.CreateBankInstallmentCampaign(this.bankInstallmentCampaign).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.BankName} bankasının ${item.Campaign} taksit kampanyasını silecektir.`).then(result=>{
                if(result){
                    this.loading = true
                    SystemParameterApi.DeleteBankInstallmentCampaign(item.Id).then(res=>{
                        this.$result(res)
                        this.loading = false
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                    }).catch(err=>{
                        this.loading = false
                        this.$result(null,err)
                    })
                }
            })
        },
        getBanks(){
            SystemDataApi.Bank(0).then(res=>{
                this.loading = false
                if(res.data.Success){
                    this.banks = res.data.Data
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>